module.exports = __webpack_public_path__ + "static/media/4_of_clubs.2d8c639a.png";